
let pagescroll = {
  init: false
};
var mySwiper;

function myFunction() {
  document.getElementById("video2").innerHTML = "<div id='player2'></div>";

  // 2. This code loads the IFrame Player API code asynchronously.
  var tag = document.createElement('script');

  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  $('.btn-play').fadeOut();
  $('.gyp-3-video-box > img').fadeOut();
}

// 3. This function creates an <iframe> (and YouTube player)
//    after the API code downloads.
var player2;
function onYouTubeIframeAPIReady() {
  player2 = new YT.Player('player2', {
    height: '390',
    width: '640',
    videoId: $('#video2').data('id'),
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange
    }
  });
}

// 4. The API will call this function when the video player is ready.
function onPlayerReady(event) {
  event.target.playVideo();
}

// 5. The API calls this function when the player state changes.
//    The function indicates that when playing a video (state=1),
//    the player should play for six seconds and then stop.
var done = false;
function onPlayerStateChange(event) {
  if (event.data == YT.PlayerState.PLAYING && !done) {
    //setTimeout(stopVideo, 6000);
    done = true;
  }
}
function stopVideo() {
  player2.stopVideo();
}


$(document).ready(function () {

  if ($(".p-gallery-photo").length && !$(".photo-item ").length) $(".gyp-2").hide();

  $(function () {
    function clearheader() {
      if (window.innerWidth <= '991') {
        $('header').removeClass('dark-color');
        $('body').removeClass('dark-color');
        $('header').removeClass('small-contact');
      }
    }
    $(window).resize(function () {
      clearheader();
    });
    clearheader();
  });

  if ($(".pagescroll").length) {
    $("body, html").addClass("has_onepage_scroll");
    pagescroll = $(".pagescroll").onepage_scroll({
      customDelayOnMove: true,
      sectionContainer: "section",     // sectionContainer accepts any kind of selector in case you don't want to use section
      easing: "ease",                  // Easing options accepts the CSS3 easing animation such "ease", "linear", "ease-in",
      // "ease-out", "ease-in-out", or even cubic bezier value such as "cubic-bezier(0.175, 0.885, 0.420, 1.310)"
      animationTime: 0,             // AnimationTime let you define how long each section takes to animate
      pagination: false,                // You can either show or hide the pagination. Toggle true for show, false for hide.
      updateURL: false,                // Toggle this true if you want the URL to be updated automatically when the user scroll to each page.
      beforeMove: function (index, customMove, direction, func) {
        // if ( $('section.sect-main-2').hasClass('active') || $('section.sect-main-3').hasClass('active') || $('section.sect-main-4').hasClass('active') ){
        //   $('header').addClass('dark-color');
        //   $('header').addClass('small-contact');
        // }
        // else{
        //   $('header').removeClass('dark-color');
        //   if ( $('section.sect-main-1').hasClass('active') ){
        //     $('header').removeClass('small-contact');
        //   }
        // }
        screenCallbackBefore(index, customMove, direction, func);
      },  // This option accepts a callback function. The function will be called before the page moves.
      afterMove: function (index, customMove, func) {
        screenCallbackAfter(index, customMove, func);
      },   // This option accepts a callback function. The function will be called after the page moves.
      loop: false,                     // You can have the page loop back to the top/bottom when the user navigates at up/down on the first/last page.
      keyboard: true,                  // You can activate the keyboard controls
      responsiveFallback: 992,        // You can fallback to normal page scroll by defining the width of the browser in which
      // you want the responsive fallback to be triggered. For example, set this to 600 and whenever
      // the browser's width is less than 600, the fallback will kick in.
      direction: "vertical"            // You can now define the direction of the One Page Scroll animation. Options available are "vertical" and "horizontal". The default value is "vertical".  
    });
    fixVH = new vhDevice(['.pagescroll, .pagescroll .section > div']);
  };
  var height1 = $('.main-1').innerHeight() - 31;
  var height2 = $('.main-1').innerHeight() + $('.main-2').innerHeight() + $('.main-3').innerHeight() + $('.main-4').innerHeight() - 31;
  if ($(window).scrollTop() > height1 && $(window).scrollTop() < height2) {
    $('header').addClass('dark-color-xs');
  }
  else {
    $('header').removeClass('dark-color-xs');
  }


  var header = $('header'),
    scrollPrev = 0;

  $(window).scroll(function () {

    var height1 = $('.main-1').innerHeight() - 31;
    var height2 = $('.main-1').innerHeight() + $('.main-2').innerHeight() + $('.main-3').innerHeight() + $('.main-4').innerHeight() - 31;
    if ($(window).scrollTop() > height1 && $(window).scrollTop() < height2) {
      $('header').addClass('dark-color-xs');
    }
    else {
      $('header').removeClass('dark-color-xs');
    }

    if ($(window).scrollTop() > height2) {
      $('header').addClass('dark-color-xs-black');
    }
    else {
      $('header').removeClass('dark-color-xs-black');
    }

    if ($('.double-header').length) {

      var headerheightFirst = $('.double-header .header-container').innerHeight();
      var scrolled = $(window).scrollTop();

      if (scrolled > 0 && scrolled > scrollPrev) {
        header.addClass('out');
      } else {
        header.removeClass('out');
      }
      scrollPrev = scrolled;
    }




  });







  $(".form-group-with-placeholder label input, .form-group-with-placeholder label textarea").focus(function () {
    $(this).parent().addClass("active");
  });
  $(".form-group-with-placeholder label input, .form-group-with-placeholder label textarea").blur(function () {
    if ($(this).val() == "") {
      $(this).parent().removeClass("active");
    }
  });

  $(".chzn-select").chosen({
    width: "100%",
    disable_search: true
  });
  $(".chzn-select").change(function () {
    $(this).parent().addClass("active");
  });

  const getDate = (date) => {
    const year = date.getUTCFullYear();
    const dayNumber = date.getUTCDate();
    const monthNumber = date.getUTCMonth();
    return year + '-' + monthNumber + '-' + dayNumber
  };
  const changeCalendarDates = (selectedDates, dateStr, instance) => {
    $(".dayContainer .flatpickr-day").each(function () {
      const labelData = $(this).attr("aria-label");
      const date = getDate(new Date(labelData));
      const viewed = viewedDates.includes(date);
      if (viewed) {
        $(this).addClass("viewed")
        console.log($(this), date)
      }
    })

  }


  $(".datapicker").flatpickr({
    disableMobile: "true",
    monthSelectorType: "static",
    dateFormat: "Y-m-d",
    disable: typeof arrData != 'undefined' ? arrData : [],
    //disable: ["2020-08-20", "2020-08-21", "2020-08-23" ],
    onReady: function () {
      //   $('span.arrowUp').html('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 17 17"><g></g><path d="M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z"></path></svg>');
      //   $('span.arrowDown').html('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 17 17"><g></g><path d="M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z"></path></svg>');
    },
    onOpen: changeCalendarDates,
    onMonthChange: changeCalendarDates,
    onYearChange: changeCalendarDates,
  });



  $(function () {
    $(".f_validate").validate({
      rules: {
        first_name: "required",
        email: {
          required: true,
          email: true
        },
        phone: "required"
      },
      messages: {
        first_name: "Required",
        email: {
          required: "Required",
          email: "Format name@domain.com"
        },
        phone: "Required"
      }
    });
  });


  $(".btn-menu").on('click', function () {
    $('body').toggleClass('menu-open');
    $(this).toggleClass("active");
    $('.header-menu').toggleClass('active');
    $('header').toggleClass('active');
  });



  if ($(".blog-slider").length) {
    var blogSlider = new Swiper('.blog-slider .swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 40,
      grabCursor: true,
      navigation: {
        nextEl: '.blog-slider .swiper-button-next',
        prevEl: '.blog-slider .swiper-button-prev',
      },
      pagination: {
        el: '.blog-slider .swiper-pagination',
        clickable: true,
      },
    });
  }

  if ($(".theatre-mode-slider").length) {
    const slides = $(".theatre-mode-slider").find(".swiper-slide");
    let defaultSlideCount = slides.length;
    $(".theatre-mode-slider .swiper-wrapper").append(slides.clone()) // clone elems
    $(".theatre-mode-slider .swiper-wrapper").append(slides.clone()) // clone elems
    $(".theatre-mode-slider .swiper-wrapper").append(slides.clone()) // clone elems

    mySwiper = new Swiper('.theatre-mode-slider', {
      centeredSlides: false,
      spaceBetween: 0,
      slidesPerView: 1,
      loop: true,
      speed: 45,
      grabCursor: true,
      navigation: {
        nextEl: '.theatre-mode-slider .swiper-button-next',
        prevEl: '.theatre-mode-slider .swiper-button-prev',
      },
      on: {
        init: function () {
          if (window.innerWidth > 991) {
            setTimeout(() => {
              this.params.speed = 1000
              this.slideTo(defaultSlideCount - 1, 0);
              $(".swiper-button-next").click();
              $(this.el).fadeTo(1000, 1)
            }, 500);
          }
        },
        transitionStart: function () {
          const elems = $(this.el).find(".swiper-slide");
          elems.removeClass("active");
          elems.eq(this.activeIndex).addClass("active");
        },
      },
      breakpoints: {
        991: {
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 60
        }
      }
    });
    if (typeof mySwiper != 'undefined') mySwiper.slideTo(defaultSlideCount, 0);
  }
  $(".photo-box-btn-all").on('click', 'a:not(.link)', function (e) {
    const top = $(window).scrollTop();
    $(this).parent().addClass("active");
    $('.photo-box .photo-item').addClass('dis-hidden');
    showMoreBoxPhoto(e, top);
  });


















  if ($(".packs-slider").length) {

    packsSwiper = new Swiper('.packs-slider', {
      centeredSlides: false,
      spaceBetween: 0,
      slidesPerView: 1,
      autoHeight: true,
      grabCursor: true,
      //loop: true,
      speed: 500,
      navigation: {
        nextEl: '.packs-slider .swiper-button-next',
        prevEl: '.packs-slider .swiper-button-prev',
      },
      pagination: {
        el: '.packs-slider .swiper-pagination',
        clickable: true,
      },

      on: {
        init: function () {

        },
        /*
        transitionStart: function () {
          const elems = $(this.el).find(".swiper-slide");
          elems.removeClass("active");
          elems.eq(this.activeIndex).addClass("active");
          alert(this.activeIndex);
        },
        */
        transitionStart: function () {
          $('.swiper-menu__item').removeClass('active');
          if (this.activeIndex == 0) {
            $('.swiper-menu__item').removeClass('active');
            $('.swiper-menu .swiper-menu__item:nth-child(1)').addClass('active');
          }
          if (this.activeIndex == 1) {
            $('.swiper-menu__item').removeClass('active');
            $('.swiper-menu .swiper-menu__item:nth-child(2)').addClass('active');
          }
          if (this.activeIndex == 2) {
            $('.swiper-menu__item').removeClass('active');
            $('.swiper-menu .swiper-menu__item:nth-child(3)').addClass('active');
          }
        },
      },

    });

  }

  $('.swiper-menu').on('click', '.swiper-menu__item', function () {
    $('.swiper-menu__item').removeClass('active');
    $(this).addClass('active');
    const index = $(this).data('index')
    packsSwiper.slideTo(index)
  });

  $('.packs-slider-head').on('click', '.packs-slider-down', function () {
    $(this).toggleClass('active');
    //$(this).parent().next().slideToggle(300);
    $(this).parent().next().slideToggle({
      duration: 300,
      progress: functionToExecute,
      complete: function () {
        console.log('animation completed');
      }
    });
    /*
        setTimeout(() => {
           packsSwiper.update();
        }, 301);
    */
  });


  function functionToExecute(animation, progress, remainingMs) {
    packsSwiper.update();
  }



  $('.header-container').on('click', '.header-menu.active .has-sub-menu > a', function () {
    $(this).toggleClass('active');
    $(this).next().stop().slideToggle(400);
  });





  /*
    $('.packs-slider-btn').on('click', 'a', function() {
      $('html,body').animate({scrollTop:$('.main-5').offset().top+"px"},{duration:1000});
    });
  */
  $('.packs-slider-btn').on('click', 'a', function () {
    console.log($(this).data('package'));
    $("select[name=services] option:selected").each(function () {
      $(this).removeAttr('selected');
    });
    $('select[name=services] option[value=' + $(this).data('package') + ']').attr('selected', 'selected');

    $(".chzn-select").chosen().trigger("chosen:updated");


    $('html,body').animate({ scrollTop: $('.main-5').offset().top + "px" }, { duration: 1000 });


  });


  $('.blog-search-btn').on('click', function () {
    $(this).toggleClass('active');
    $('.blog-search-form').toggleClass('active');
  });

  $('.blog-article-head-right > span').on('click', function () {
    //$(this).toggleClass('active');
    if ($(this).next().hasClass('active')) {
      $(this).next().removeClass('active');
    }
    else {
      $('.blog-article-head-right > div').removeClass('active');
      $(this).next().addClass('active');
    }
  });











  $(".fancy-modal").fancybox({
    speed: 330,
    touch: false,
    autoFocus: false,
    closeExisting: true
  });

  $(".fancy-video").fancybox({
    helpers: {
      media: true
    },
    youtube: {
      autoplay: 0,
      showinfo: 0
    },
    vimeo: {
      color: '000'
    },
    afterShow: function () {
      $("#cursor").hide();
    },
    afterClose: function () {
      $("#cursor").show();
    }
  });

  $('input.datapicker').insertAfter('.ic-date');
  $('.ic-date svg, .ic-date path').remove();
  $('<svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.625 9.125C2.51562 9.125 2.42188 9.09375 2.34375 9.03125C2.28125 8.95312 2.25 8.85938 2.25 8.75V6.5C2.25 6.39062 2.28125 6.30469 2.34375 6.24219C2.42188 6.16406 2.51562 6.125 2.625 6.125H4.875C4.98438 6.125 5.07031 6.16406 5.13281 6.24219C5.21094 6.30469 5.25 6.39062 5.25 6.5V8.75C5.25 8.85938 5.21094 8.95312 5.13281 9.03125C5.07031 9.09375 4.98438 9.125 4.875 9.125H2.625ZM9.375 2C9.6875 2 9.95312 2.10938 10.1719 2.32812C10.3906 2.54688 10.5 2.8125 10.5 3.125V11.375C10.5 11.6875 10.3906 11.9531 10.1719 12.1719C9.95312 12.3906 9.6875 12.5 9.375 12.5H1.125C0.8125 12.5 0.546875 12.3906 0.328125 12.1719C0.109375 11.9531 0 11.6875 0 11.375V3.125C0 2.8125 0.109375 2.54688 0.328125 2.32812C0.546875 2.10938 0.8125 2 1.125 2H2.25V0.875C2.25 0.765625 2.28125 0.679688 2.34375 0.617188C2.42188 0.539062 2.51562 0.5 2.625 0.5H3.375C3.48438 0.5 3.57031 0.539062 3.63281 0.617188C3.71094 0.679688 3.75 0.765625 3.75 0.875V2H6.75V0.875C6.75 0.765625 6.78125 0.679688 6.84375 0.617188C6.92188 0.539062 7.01562 0.5 7.125 0.5H7.875C7.98438 0.5 8.07031 0.539062 8.13281 0.617188C8.21094 0.679688 8.25 0.765625 8.25 0.875V2H9.375ZM9.375 11.2344V4.25H1.125V11.2344C1.125 11.3281 1.17188 11.375 1.26562 11.375H9.23438C9.32812 11.375 9.375 11.3281 9.375 11.2344Z" fill="#2D9CDB"/></svg>').appendTo('.ic-date');


  //$(".f_validate br, .f_validate p:not(.ic-date + p)").remove();
  $(".f_validate br, .f_validate p").remove();

  $('.footer-left .formSubmit svg, .footer-left .formSubmit circle').remove();
  $('<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><circle opacity="0.1" cx="40" cy="40" r="35" stroke="#2D9CDB" stroke-width="10"></circle></svg>').appendTo('.footer-left .formSubmit');



  $('.chzn-select').each(function () {
    if (($(this).val() !== "" || $(this).val() !== null)) {
      $(this).parent().addClass("active");
    }
  });

  if ($('.photo-box > .photo-item').length < 5) {
    $('.photo-box > .photo-item').css('display', 'block');
  }











});

function roundPlus(x, n) { //x - число, n - количество знаков 
  if (isNaN(x) || isNaN(n)) return false;
  var m = Math.pow(10, n);
  return Math.round(x * m) / m;
}

var planingPriceTotal = parseFloat($('.packages-price-planing').data('price-total'), 10);
var photoPriceTotal = parseFloat($('.packages-price-photo').data('price-total'), 10);
var videoPriceTotal = parseFloat($('.packages-price-video').data('price-total'), 10);
var planingPriceMonth = roundPlus(planingPriceTotal / 12, 2);
var photoPriceMonth = roundPlus(photoPriceTotal / 12, 2);
var videoPriceMonth = roundPlus(videoPriceTotal / 12, 2);
var summPriceTotal = 0;
var summPriceMonth = 0;

function printPrices(summPriceTotal, summPriceMonth) {
  $('.price-month').text(summPriceMonth);
  $('.price-total').text(summPriceTotal);
}


function calcPriceTotalMonth() {
  //disabled all
  if (!$('.packages-price-planing').prop('checked') && !$('.packages-price-photo').prop('checked') && !$('.packages-price-video').prop('checked')) {
    summPriceTotal = 0;
    summPriceMonth = 0;
  }
  //enable 1
  if ($('.packages-price-planing').prop('checked') && !$('.packages-price-photo').prop('checked') && !$('.packages-price-video').prop('checked')) {
    summPriceTotal = planingPriceTotal;
    summPriceMonth = roundPlus(summPriceTotal / 12, 2);
  }
  //enable 2
  if (!$('.packages-price-planing').prop('checked') && $('.packages-price-photo').prop('checked') && !$('.packages-price-video').prop('checked')) {
    summPriceTotal = photoPriceTotal;
    summPriceMonth = roundPlus(summPriceTotal / 12, 2);
  }
  //enable 3
  if (!$('.packages-price-planing').prop('checked') && !$('.packages-price-photo').prop('checked') && $('.packages-price-video').prop('checked')) {
    summPriceTotal = videoPriceTotal;
    summPriceMonth = roundPlus(summPriceTotal / 12, 2);
  }
  //enable 1 2
  if ($('.packages-price-planing').prop('checked') && $('.packages-price-photo').prop('checked') && !$('.packages-price-video').prop('checked')) {
    summPriceTotal = planingPriceTotal + photoPriceTotal;
    summPriceMonth = roundPlus(summPriceTotal / 12, 2);
  }
  //enable 1 3
  if ($('.packages-price-planing').prop('checked') && !$('.packages-price-photo').prop('checked') && $('.packages-price-video').prop('checked')) {
    summPriceTotal = planingPriceTotal + videoPriceTotal;
    summPriceMonth = roundPlus(summPriceTotal / 12, 2);
  }
  //enable 2 3
  if (!$('.packages-price-planing').prop('checked') && $('.packages-price-photo').prop('checked') && $('.packages-price-video').prop('checked')) {
    summPriceTotal = photoPriceTotal + videoPriceTotal;
    summPriceMonth = roundPlus(summPriceTotal / 12, 2);
  }
  //enable 1 2 3
  if ($('.packages-price-planing').prop('checked') && $('.packages-price-photo').prop('checked') && $('.packages-price-video').prop('checked')) {
    summPriceTotal = planingPriceTotal + photoPriceTotal + videoPriceTotal;
    summPriceMonth = roundPlus(summPriceTotal / 12, 2);
  }

  printPrices(summPriceTotal, summPriceMonth);


  console.log(summPriceMonth + ' - ' + summPriceTotal);
}


$(document).ready(function () {
  calcPriceTotalMonth();
  $(document).on('change', '.packages-listItem input', calcPriceTotalMonth);

  $(function () {
    $('.drag').dragscroll({ direction: 'scrollLeft' });
  });

  if ($(".photo-box .photo-item").length) {
    const count = $(".photo-box .photo-item").length;
    const ceil = Math.floor(count / 3);
    $(`.photo-box .photo-item`).eq(ceil).addClass("secondColumn")
  };
});














$(".quick_view").fancybox({
  baseClass: "quick-view-container",
  infobar: false,
  buttons: false,
  thumbs: false,
  margin: 0,
  touch: {
    vertical: false
  },
  animationEffect: 'fade',
  transitionEffect: "slide",
  transitionDuration: 500,
  baseTpl:
    '<div class="fancybox-container" role="dialog">' +
    '<div class="quick-view-content">' +
    '<div class="quick-view-carousel">' +
    '<div class="fancybox-stage"></div>' +
    "</div>" +
    '<div class="quick-view-top"><svg width="146" height="10" viewBox="0 0 146 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.73598 1.81939V0.159363H0V1.81939H2.92749V9.84064H4.91447V1.81939H7.73598Z" fill="white" style="transition-delay: 500ms;"></path><path d="M19.9271 9.84064V0.159363H17.9402V3.78486H14.1119V0.159363H12.1249V9.84064H14.1119V5.44489H17.9402V9.84064H19.9271Z" fill="white" style="transition-delay: 600ms;"></path><path d="M32.3614 9.84064V8.18061H27.129V5.67065H31.7521V4.01062H27.129V1.81939H32.123V0.159363H25.142V9.84064H32.3614Z" fill="white" style="transition-delay: 700ms;"></path><path d="M52.3148 6.53386H50.3809C50.2616 7.76892 49.4801 8.32669 48.2482 8.32669C46.7116 8.32669 45.8108 7.14475 45.8108 5.0332C45.8108 2.89509 46.7513 1.69987 48.3144 1.69987C49.3874 1.69987 50.0894 2.19124 50.3809 3.43958H52.2751C52.1029 1.2085 50.4206 0 48.2482 0C45.5194 0 43.8238 1.87251 43.8238 5.00664C43.8238 8.11421 45.5061 10 48.1952 10C50.5928 10 52.1956 8.75166 52.3148 6.53386Z" fill="white" style="transition-delay: 800ms;"></path><path d="M58.9339 9.84064V0.159363H56.9469V9.84064H58.9339Z" fill="white" style="transition-delay: 900ms;"></path><path d="M71.8667 9.84064V0.159363H69.8798V6.74635L66.0515 0.159363H64.0115V9.84064H65.9985V3.14741L69.8798 9.84064H71.8667Z" fill="white" style="transition-delay: 1000ms;"></path><path d="M84.248 9.84064V8.18061H79.0156V5.67065H83.6387V4.01062H79.0156V1.81939H84.0096V0.159363H77.0287V9.84064H84.248Z" fill="white" style="transition-delay: 1100ms;"></path><path d="M96.5142 6.93227C96.5142 5.40505 95.7459 4.68792 93.9576 4.34263L92.4475 4.05047C91.0302 3.77158 90.6195 3.4927 90.6195 2.78885C90.6195 2.05843 91.2686 1.59363 92.2886 1.59363C93.547 1.59363 94.3153 2.12483 94.3153 3.10757H96.1698C96.1698 1.06242 94.7392 0 92.3813 0C90.0632 0 88.7253 1.08898 88.7253 2.97477C88.7253 4.48871 89.4803 5.19256 91.4408 5.57769L92.7919 5.84329C94.1166 6.1089 94.6067 6.38778 94.6067 7.17132C94.6067 7.98141 93.8649 8.40637 92.6595 8.40637C91.3083 8.40637 90.487 7.83533 90.487 6.79947H88.5531C88.5531 8.87118 90.0897 10 92.5535 10C95.0439 10 96.5142 8.89774 96.5142 6.93227Z" fill="white" style="transition-delay: 1200ms;"></path><path d="M108.133 1.81939V0.159363H100.397V1.81939H103.324V9.84064H105.311V1.81939H108.133Z" fill="white" style="transition-delay: 1300ms;"></path><path d="M121.191 5.05976C121.191 2.13811 119.35 0 116.529 0C113.694 0 111.892 2.2178 111.892 4.99336C111.892 7.88845 113.707 10 116.542 10C119.35 10 121.191 7.88845 121.191 5.05976ZM119.204 5.04648C119.204 7.02523 118.131 8.30013 116.542 8.30013C114.939 8.30013 113.879 7.02523 113.879 4.99336C113.879 3.04117 114.939 1.69987 116.542 1.69987C118.171 1.69987 119.204 3.02789 119.204 5.04648Z" fill="white" style="transition-delay: 1400ms;"></path><path d="M133.952 9.84064V9.48207C133.647 9.30943 133.528 9.11023 133.528 8.68526C133.475 5.83001 133.422 5.69721 132.19 5.166C133.276 4.74104 133.819 3.9575 133.819 2.77556C133.819 1.2749 132.932 0.159363 131.223 0.159363H126.044V9.84064H128.031V6.00266H130.309C131.17 6.00266 131.541 6.34794 131.541 7.15803L131.515 8.18061C131.515 9.08367 131.568 9.37583 131.819 9.84064H133.952ZM131.833 3.05445C131.833 3.91766 131.554 4.34263 130.428 4.34263H128.031V1.81939H130.428C131.515 1.81939 131.833 2.2178 131.833 3.05445Z" fill="white" style="transition-delay: 1500ms;"></path><path d="M146 0.159363H143.775L141.933 4.43559L139.96 0.159363H137.747L140.953 6.25498V9.84064H142.94V6.25498L146 0.159363Z" fill="white" style="transition-delay: 1600ms;"></path></svg><button data-fancybox-close class="quick-view-close"><span>Close</span><svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.4623 3.84836L9.40165 2.7877L6.75 5.43935L4.09835 2.7877L3.03769 3.84836L5.68934 6.50001L3.03769 9.15166L4.09835 10.2123L6.75 7.56067L9.40165 10.2123L10.4623 9.15166L7.81066 6.50001L10.4623 3.84836Z" fill="white"/></svg></button></div>' +
    '<div class="quick-view-bottom">123</div>' +
    '<div class="fancybox-navigation"><button data-fancybox-prev="" class="fancybox-button fancybox-button--arrow_left" title="Previous" disabled=""><div><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-4.76837e-07 5L5.25 0L6 0.714286L1.5 5L6 9.28571L5.25 10L-4.76837e-07 5Z" fill="white"/></svg></div></button><button data-fancybox-next="" class="fancybox-button fancybox-button--arrow_right" title="Next"><div><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 5L0.75 0L0 0.714286L4.5 5L0 9.28571L0.75 10L6 5Z" fill="white"/></svg></div></button></div>' +
    "</div>" +
    "</div>",

  onInit: function (instance) {
    /*

        #1 Create bullet navigation links
        =================================

    */

    var bullets = '<ul class="quick-view-bullets">';

    for (var i = 0; i < instance.group.length; i++) {
      bullets += '<li><a data-index="' + i + '" href="javascript:;"><span>' + (i + 1) + "</span></a></li>";
    }

    bullets += "</ul>";

    $(bullets)
      .on("click touchstart", "a", function () {
        var index = $(this).data("index");

        $.fancybox.getInstance(function () {
          this.jumpTo(index);
        });
      })
      .appendTo(instance.$refs.container.find(".quick-view-carousel"));

    /*

        #2 Add product form
        ===================

    */

    var $element = instance.group[instance.currIndex].opts.$orig;
    var cont_id = $element.data("qw-cont");

    instance.$refs.container.find(".quick-view-bottom").append(
      // In this example, this element contains the form
      $("#" + cont_id)
        .clone(true)
        .removeClass("hidden")
    );
  },

  beforeShow: function (instance) {
    /*
        Mark current bullet navigation link as active
    */

    instance.$refs.container
      .find(".quick-view-bullets")
      .children()
      .removeClass("active")
      .eq(instance.currIndex)
      .addClass("active");
  }
});

